import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import VueSocketIO from 'vue-socket.io'

// directive
import './directive/uniform'
import './directive/tooltip'

import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'

import './assets/style.css'

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: '/',
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
    },
    options: { path: '/raw_data/socket.io', transports: ['polling'] }
  })
)

Vue.use(DatePicker)
Vue.use(VueSweetalert2, {
  timer: 10000
})

Vue.component('v-select', vSelect)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
